const extractSubdomain = (hostname: string): string => {
  const matched = /^([^.]+)\.[^.]+\..+$/.exec(hostname);
  return matched ? matched[1] : '';
};

const makeApiUrl = (): URL => {
  const requestedSubdomain = extractSubdomain(location.hostname);
  const apiURL = new URL(import.meta.env.VITE_API_ENDPOINT);
  apiURL.host = requestedSubdomain
    ? `${requestedSubdomain}.${apiURL.hostname}`
    : apiURL.hostname;
  return apiURL;
};

export {
  makeApiUrl,
};
